export function setFiltersBasedOnWorkQ(filter) {
    if (filter) {
        let string = ''
        for (const [key, value] of Object.entries(filter)) {
            if (value) {
                if (filter[key].constructor == Array) { // check if is array
                    let combinedValues = ''
                    filter[key].forEach((item, index) => {
                        combinedValues = combinedValues + item?.value + (index < filter[key].length-1 ? ',' : '')
                    })
                    string = string + `&${key}=${combinedValues}`
                }  else {
                    string = string + `&${key}=${filter[key]?.value}`
                }
            }
        }

        return string
    }

    return null
}

export function stickyItems(filteredData, rowData) {
    if (filteredData && rowData) {

        let stickyItems = []
        filteredData.forEach((element, element_index) => {
            element.items.forEach((item, item_index) => {
                if (item.isSticky) {
                    stickyItems.push({
                        ...item,
                        index: `index_${element_index}_${item_index}`
                    })
                }
            })
        });

        setTimeout(() => {
            stickyItems.forEach((item, index) => {
                if (index) {
                    let totalWidth = 0
                    for (let i = 0; i < index; i++) {
                        const itemsBefore = document.querySelectorAll(`[data-index="${stickyItems[i].index}"]`);

                        totalWidth = totalWidth + itemsBefore[0]?.getBoundingClientRect().width
                    }

                    stickyItems[index].left = totalWidth
                }
            })

            return stickyItems
        }, 300)               
    }

    return 0
}